import React, { FC } from 'react';
import styled from 'styled-components';
import { SkeletonBlock, SkeletonPageHeader, SkeletonPageShell, SkeletonRow, SkeletonStack } from 'src/components/widgets/skeleton';

const ColorSystemSkeletonShell = styled(SkeletonPageShell)``;

const ColorSystemSkeletonHeader = styled(SkeletonPageHeader)``;

const ColorSystemTableSkeleton = styled.div`
    border: 1px solid ${(props) => props.theme.app.borderColor};
    border-radius: 8px;
    background: #ffffff;
    overflow: hidden;
    min-width: 0;
`;

const ColorSystemTableRowSkeleton = styled.div`
    display: grid;
    grid-template-columns: minmax(180px, 1fr) 84px;
    gap: 18px;
    align-items: center;
    min-height: 58px;
    padding: 14px 18px;
    border-bottom: 1px solid ${(props) => props.theme.skeleton.backgroundColor};
    min-width: 0;

    &:last-child {
        border-bottom: 0;
    }
`;

const ColorSystemSectionSkeleton = styled.div`
    border: 1px solid ${(props) => props.theme.app.borderColor};
    border-radius: 8px;
    background: #ffffff;
    padding: 24px;
    min-width: 0;
`;

const ColorSystemGridSkeleton = styled.div`
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px;
    min-width: 0;

    @media (max-width: 760px) {
        grid-template-columns: minmax(0, 1fr);
    }
`;

export const ColorSystemPageSkeleton: FC = () => (
    <ColorSystemSkeletonShell aria-hidden='true'>
        <ColorSystemSkeletonHeader>
            <SkeletonStack $gap='8px' $flex='1'>
                <SkeletonBlock $width='min(180px, 100%)' $height='26px' />
                <SkeletonBlock $width='min(320px, 100%)' $height='13px' />
            </SkeletonStack>
            <SkeletonBlock $width='86px' $height='36px' $radius='6px' />
        </ColorSystemSkeletonHeader>
        <ColorSystemTableSkeleton>
            {Array.from({ length: 7 }).map((_, index) => (
                <ColorSystemTableRowSkeleton key={index}>
                    <SkeletonBlock $width={index % 2 === 0 ? '220px' : '150px'} $height='15px' />
                    <SkeletonRow $gap='8px' $justify='flex-end'>
                        <SkeletonBlock $width='28px' $height='28px' $radius='4px' />
                        <SkeletonBlock $width='28px' $height='28px' $radius='4px' />
                    </SkeletonRow>
                </ColorSystemTableRowSkeleton>
            ))}
        </ColorSystemTableSkeleton>
    </ColorSystemSkeletonShell>
);

export const ColorSystemPalettePageSkeleton: FC = () => (
    <ColorSystemSkeletonShell aria-hidden='true'>
        <ColorSystemSkeletonHeader>
            <SkeletonStack $gap='8px' $flex='1'>
                <SkeletonBlock $width='min(260px, 100%)' $height='26px' />
                <SkeletonBlock $width='min(420px, 100%)' $height='13px' />
            </SkeletonStack>
        </ColorSystemSkeletonHeader>
        <SkeletonStack $gap='18px'>
            <ColorSystemSectionSkeleton>
                <SkeletonStack $gap='14px'>
                    <SkeletonBlock $width='120px' $height='20px' />
                    <ColorSystemGridSkeleton>
                        <SkeletonBlock $height='40px' $radius='6px' />
                        <SkeletonBlock $height='40px' $radius='6px' />
                    </ColorSystemGridSkeleton>
                </SkeletonStack>
            </ColorSystemSectionSkeleton>
            <ColorSystemSectionSkeleton>
                <SkeletonStack $gap='14px'>
                    <SkeletonBlock $width='160px' $height='20px' />
                    {Array.from({ length: 5 }).map((_, index) => (
                        <SkeletonRow key={index} $gap='12px'>
                            <SkeletonBlock $width='28px' $height='28px' $radius='50%' />
                            <SkeletonBlock $width={index % 2 === 0 ? '170px' : '120px'} $height='14px' />
                            <SkeletonBlock $width='80px' $height='28px' $radius='4px' />
                        </SkeletonRow>
                    ))}
                </SkeletonStack>
            </ColorSystemSectionSkeleton>
        </SkeletonStack>
    </ColorSystemSkeletonShell>
);
